/* eslint-disable max-len */
/* eslint-disable no-console */
import { Container, Grid, useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import FeedTitleHeader from './Components/FeedTitleHeader';
import LeftPart from './Components/LeftPart';
import Notification from './Components/Reusable/Notification';
import RightPart from './Components/RightPart';

export const feedRoutes = [ 'celebrationevents', 'bookmarks', 'popularfeeds', 'connections', 'myactivity', 'draft', 'feeds', 'pendingapproval' ];

interface Action {
	0: 'allEventCmnt' | 'comments';
	1: any;
  }

type FeedActionOld = [] | Action;
export interface FeedAction {
	comments?: any // to display feed comments on right side
	all_event_comment?: any;
	new_feed?: any; // for patching new feed to feed list
	remove_feed?:any // for removing a particular feed from list (either pass index in obj or the original obj)
	bookmark_add?: any; // for appending new bookmarked feed side bookmark component
	bookmark_remove?: any; // for appending new bookmarked feed side bookmark component
	report_feed?:any;// for reporting a news feed
	report_tag?:any;// for showing a tag after reporting a feed and to remove the feed from that list
	feedCommentCount?:any; // to display feed comments count
	comments_add?:any
	add_like?:any; // to change like if modified from popular feeds
	is_full_screen?:boolean; // to check if feed is being viewd in full screen or not
	edit_feed?:any
}

type FeedActionTypes = 'comments'
| 'all_event_comment'
| 'new_feed'
| 'remove_feed'
| 'bookmark_add'
| 'bookmark_remove'
| 'report_feed'
| 'report_tag'
| 'feedCommentCount'
| 'comments_add'
| 'add_like'
| 'edit_feed'
| 'is_full_screen';
export interface HandleFeedAction {
	(action: 'append' | 'remove', key: FeedActionTypes, value?:any) : void;
}
interface ContextInterface
{
	feedAction:FeedAction;
	handleFeedAction:HandleFeedAction;
	feedCardActn:FeedActionOld;
	// feedCardActn:any;
	setFeedCardActn:any;
}
export type FeedActionContext = ContextInterface | {
	feedAction: FeedAction;
	handleFeedAction: () => void;
	feedCardActn: [string, any];
	setFeedCardActn: () => void;
};
export const feedActionContext = createContext<FeedActionContext>({
	feedAction       : {},
	handleFeedAction : () => {},
	feedCardActn     : [],
	setFeedCardActn  : () => {}
});

const NewsfeedRevised = () =>
{
	const { type } = useParams();
	const [ searchParams ] = useSearchParams();
	const paramsValue = searchParams.get('post');
	const isMobileSM = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
	const isMobileS = useMediaQuery((theme: Theme) => theme.breakpoints.down(500));
	const [ feedCardActn, setFeedCardActn ] = useState<FeedActionOld>([]);
	const [ feedAction, setFeedAction ] = useState<FeedAction>({});
	const [ selectedFilter, setSelectedFilter ] = useState<any>({});
	const [ inputValue, setInputValue ] = useState<any>('');

	const handleFeedAction:HandleFeedAction = useCallback((action, key, value?) =>
	{
		if (action === 'append') setFeedAction((prev) => ({ ...prev, [key]: value }));
		else if (action === 'remove') setFeedAction((prev) => ({ ...prev, [key]: null }));
	}, []);

	useEffect(() =>
	{
		setFeedCardActn([]);
		setFeedAction({});
	}, [ paramsValue, type ]);

	const contextValue = useMemo(() => ({
		feedAction,
		handleFeedAction,
		feedCardActn,
		setFeedCardActn
	}), [ feedCardActn, feedAction, handleFeedAction ]);

	return (
		<feedActionContext.Provider value={contextValue}>
			<Grid container sx={{ minHeight: '90%' }} flexDirection={'column'} flex={'none'} flexWrap={'nowrap'}>
				<FeedTitleHeader
					setInputValue={setInputValue}
					selectedFilter={selectedFilter}
					setFeedCardActn={setFeedCardActn}
					inputValue={inputValue}
					setSelectedFilter={setSelectedFilter}
					// initialFeedLength={initialFeedLength}
				/>
				<Grid container sx={{ height: 'var(--percent100)' }} item px='var(--pixel8)'>
					<Container sx={{ maxWidth: isMobileS ? '100%' : '85%' }} maxWidth={false} disableGutters>
						<Grid container height='var(--percent100)'> {/* Full height grid */}
							{feedAction?.report_tag && <Notification />}
							{/* <Grid item xs={12} md={type === 'celebrationevents' ? 12 : 8} p={'0 8px'}> */}
							<Grid item xs={12} md={8} p={'0 8px'}>
								{/* Passing props to LeftPart */}
								<LeftPart
									searchVal={inputValue}
									selectedFilter={selectedFilter}
									setSelectedFilter={setSelectedFilter}
								/>
							</Grid>
							{!isMobileSM &&
							<Grid item xs={12} md={4}
							// display={type === 'celebrationevents' ? 'none' : ''}
								display='flex'
								py={2}
							>
								<RightPart key={type}setSelectedFilter={setSelectedFilter} />
							</Grid>}
						</Grid>
					</Container>
				</Grid>
			</Grid>
		</feedActionContext.Provider >
	);
};

export default NewsfeedRevised;
